import { Exchange, Instrument } from '@/types/generated/common/types'

const instrumentMaps = new WeakMap<Instrument[], Map<string, Instrument>>()

/** Catalog arrays are immutable query results; share their index across hook instances. */
export function getInstrumentSymbolMap(instruments: Instrument[]): Map<string, Instrument> {
  const cached = instrumentMaps.get(instruments)
  if (cached) return cached
  const map = new Map(instruments.map((instrument) => [instrument.symbol, instrument]))
  instrumentMaps.set(instruments, map)
  return map
}

const EMPTY_INSTRUMENT_MAP = new Map<string, Instrument>()

/**
 * A row's instrument map, taken from ITS OWN exchange in the per-exchange map
 * (useMultiExchangeInstrumentMap), never the selected account's: cross-account tables mix
 * venues, and borrowing another exchange's instruments by symbol collision silently gives
 * wrong base/quote/type. Unknown exchange or map → one shared empty map (stable identity).
 */
export function getInstrumentMapForExchange(
  multiExchangeInstrumentMap: Map<Exchange, Map<string, Instrument>> | undefined,
  exchange: Exchange | undefined
): Map<string, Instrument> {
  if (exchange === undefined) return EMPTY_INSTRUMENT_MAP
  return multiExchangeInstrumentMap?.get(exchange) ?? EMPTY_INSTRUMENT_MAP
}
